import { useState, useEffect } from "react";

export function useLoadingSequence() {
  const [beatsVisible, setBeatsVisible] = useState(false);
  const [uiVisible, setUiVisible] = useState(false);
  const [introCompleted, setIntroCompleted] = useState(false);

  useEffect(() => {
    // Loading sequence:
    // 1. Show Beats component first (centered)
    const beatsTimer = setTimeout(() => {
      setBeatsVisible(true);
    }, 100);

    // 2. After Beats fades in, show the rest of the UI
    const uiTimer = setTimeout(() => {
      setUiVisible(true);
      setIntroCompleted(true);
    }, 600); // Wait for Beats fade-in to complete and give user time to see it

    return () => {
      clearTimeout(beatsTimer);
      clearTimeout(uiTimer);
    };
  }, []);

  return { beatsVisible, uiVisible, introCompleted, setUiVisible };
}
